<template>
  <div id="index">hello</div>
</template>

<script>

  export default {
    name: "Index"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Index.vue